import loadable from '@loadable/component';

export const InvoicesLinksLoadable = loadable(
  () =>
    import(
      /* webpackChunkName: "InvoicesLinks" */
      './InvoicesLinks.dynamic'
    ),
);
